import(/* webpackMode: "eager" */ "/builds/raabe/raabe-de/raabe-portal/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/raabe/raabe-de/raabe-portal/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderModuleView"] */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/entities/header-module/header-module.view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavItemFooterPrimaryView"] */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/entities/nav-item/nav-item-footer-primary.view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavItemFooterSecondaryView"] */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/entities/nav-item/nav-item-footer-secondary.view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductImageView"] */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/entities/product-page/product-image.view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductShoppingCardView"] */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/entities/product-page/product-shopping-card.view.tsx");
